import { DefaultQueryParams, parseQuery, resizeGame } from '@pascal/pascal-core';
import { oddballBetShopGameId } from '../enums';

let maxHeight;
let maxWidth;

const target = document.querySelector('.root');
export const resizeGameHandler = () => {
  const { [DefaultQueryParams.GameId]: gameId } = parseQuery(window.location.search);
  const isBetShop = +gameId === oddballBetShopGameId;
  const isTerminal = parseQuery(window.location.search)[DefaultQueryParams.IsCashDesk] === 'true';

  if (isTerminal) {
    maxHeight = 1080;
    maxWidth = 1920;
    target.classList.add('terminal-root');
  } else if (isBetShop) {
    maxHeight = 1080;
    maxWidth = 1920;
  } else {
    maxHeight = 700;
    maxWidth = 1202;
  }
  resizeGame(maxHeight, maxWidth, target);
};
